module.exports = __webpack_public_path__ + "1cdc8fce9609d07f0e9d8d0bc4b61f8f.svg";